"use client"

import { AlertTriangle } from "lucide-react"
import { Button } from "./ui/button"
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "./ui/dialog"

interface InterviewOwnershipModalProps {
  isOpen: boolean
  onClose: () => void
  creatorName: string
  currentUserName: string
  onConfirm: () => void
  onRescheduleKeepOwner: () => void
  isSubmitting?: boolean
}

export function InterviewOwnershipModal({
  isOpen,
  onClose,
  creatorName,
  currentUserName,
  onConfirm,
  onRescheduleKeepOwner,
  isSubmitting = false,
}: InterviewOwnershipModalProps) {
  return (
    <Dialog open={isOpen} onOpenChange={(open) => !open && !isSubmitting && onClose()}>
      <DialogContent className="w-[95vw] max-w-xl rounded-xl border border-gray-200 bg-white shadow-xl p-0 z-[100] gap-0">
        <DialogHeader className="px-6 pt-6 pb-4 border-b border-gray-100">
          <div className="flex items-start gap-3">
            <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-amber-100">
              <AlertTriangle className="h-5 w-5 text-amber-600" />
            </div>
            <div className="space-y-1 text-left">
              <DialogTitle className="text-lg font-semibold text-gray-900">
                Application Ownership
              </DialogTitle>
              <DialogDescription className="text-sm text-gray-600 leading-relaxed">
                This application was created by{" "}
                <span className="font-semibold text-gray-900">{creatorName}</span>.
              </DialogDescription>
            </div>
          </div>
        </DialogHeader>

        <div className="px-6 py-4 text-sm text-gray-700 leading-relaxed">
          <p>
            You are rescheduling as{" "}
            <span className="font-semibold text-gray-900">{currentUserName}</span>. Choose whether
            to transfer ownership or keep{" "}
            <span className="font-semibold text-gray-900">{creatorName}</span> as the owner.
          </p>
        </div>

        <div className="px-6 py-4 bg-gray-50 border-t border-gray-100 flex flex-col gap-2">
          <Button
            type="button"
            onClick={onConfirm}
            disabled={isSubmitting}
            className="w-full h-11 rounded-lg bg-orange-600 hover:bg-orange-700 text-white whitespace-normal text-center"
          >
            {isSubmitting ? "Processing…" : "Continue as owner"}
          </Button>
          <Button
            type="button"
            variant="outline"
            onClick={onRescheduleKeepOwner}
            disabled={isSubmitting}
            className="w-full h-11 rounded-lg border-orange-200 text-orange-700 hover:bg-orange-50 whitespace-normal text-center"
          >
            {isSubmitting ? "Processing…" : "Reschedule & keep existing owner"}
          </Button>
          <Button
            type="button"
            variant="outline"
            onClick={onClose}
            disabled={isSubmitting}
            className="w-full h-11 rounded-lg border-gray-200 whitespace-normal text-center"
          >
            Cancel
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  )
}
